import * as React from "react";
import { useDispatch, useSelector } from "@teamprevent/admin-redux";
import { Loader } from "semantic-ui-react";

import { employeeImmunisationsSelector, basePathSelector } from "../selectors";
import { useEmployeeRecordDetailsModel } from "../../crud/employeeRecord/hooks";
import { useCustomerDetailsModel } from "../../crud/customer/hooks";
import { ApplicationState } from "../../applicationState";
import { ImmunisationType, loadImmunisationTypes } from "../../crud/immunisationType";

import { AllImmunisationRecords } from "./AllImmunisationRecords";

export const All: React.FunctionComponent = () => {
    const [immsTypeOptions, setImmsTypeOptions] = React.useState<any[]>([]);

    const path = useSelector((state: ApplicationState) => basePathSelector(state));
    const allImmunisations = useSelector((state: ApplicationState) => employeeImmunisationsSelector(state));
    const customerId = useSelector((state: ApplicationState) => state.router.params!.customerId);
    const employeeRecordId = useSelector((state: ApplicationState) => state.router.params!.employeeRecordId);
    const { customer, isLoaded: isCustomerLoaded } = useCustomerDetailsModel({ customerId });
    const { employeeRecord, isLoaded: isEmployeeLoaded } = useEmployeeRecordDetailsModel({ employeeRecordId, customerId });
    const immunisationTypes: ImmunisationType[] = useSelector((state: ApplicationState) => state.immunisationTypes);

    const dispatch = useDispatch();

    React.useEffect(() => {
        dispatch(loadImmunisationTypes());
    }, [dispatch]);

    React.useEffect(() => {
        const options = (immunisationTypes ?? []).map(type => ({
            key: type.id,
            value: type.id,
            text: type.name
        }));
        setImmsTypeOptions(options);
    }, [immunisationTypes]);

    if (isCustomerLoaded === false || isEmployeeLoaded === false) {
        return <Loader active>Loading</Loader>;
    }

    return (
        <AllImmunisationRecords
            customer={customer}
            employeeRecord={employeeRecord}
            allImmunisations={allImmunisations}
            immsTypeOptions={immsTypeOptions}
            path={path}
        />
    );
};
